/**
 * Le seul obstacle attendu à la première ouverture : un compte Discord qui
 * n'est rattaché à aucun compte Pop Movie.
 *
 * On ne crée pas de compte à la volée — Discord ne fournit pas d'adresse
 * e-mail sans un scope dédié, et `users.email` est unique et obligatoire.
 * L'écran renvoie donc vers `/link`, la commande du bot qui fait déjà ce
 * travail.
 */
export default function NonLie({ discord, raison, message }) {
  const desactive = raison === 'account_disabled';

  return (
    <div className="centre">
      <div className="emoji">{desactive ? '🚫' : '🔗'}</div>
      <h1 className="titre">
        {desactive ? 'Compte désactivé' : 'Ton compte n’est pas encore lié'}
      </h1>

      <p className="discret">
        {message || 'Ce compte Discord n’est rattaché à aucun compte Pop Movie.'}
      </p>

      {!desactive && (
        <ol className="marche-a-suivre">
          <li>Sur le serveur, tape <code>/link</code></li>
          <li>Le bot te donne un code</li>
          <li>Colle-le sur le site, dans ton profil</li>
          <li>Reviens ici</li>
        </ol>
      )}

      {discord?.display_name && (
        <p className="discret petit">Connecté à Discord en tant que {discord.display_name}</p>
      )}
    </div>
  );
}
